import React, { useState, useEffect, useMemo } from "react";
import { renderToString } from "react-dom/server";

import {
  MapContainer,
  TileLayer,
  LayersControl,
  GeoJSON,
  LayerGroup,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.fullscreen";
import "leaflet.fullscreen/Control.FullScreen.css";

import L from "leaflet";
import {
  Select,
  Form,
  Row,
  Col,
  Card,
  Table,
  Modal,
  Button,
  Collapse,
  Tooltip,
  Spin,
  Switch,
} from "antd";
import {
  ReloadOutlined,
  AlertOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// Importa las imágenes desde node_modules
import iconUrl from "leaflet/dist/images/marker-icon.png";
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";
import "./EstilosGeovisor.css";
import { useSelector } from "react-redux";
import { selectAppPermissions } from "../../store/auth/selectors";

import {
  styleresguardoIndigenaFormalizado,
  stylezonaReservaCampesinaConstituida,
  styleconsejosComunitarios,
  styleVisitasPatti,
  stylereservaForestalNacional,
  stylerunap,
  styledesagregacionRegional,
} from "./mapStyles";
import getVisitasTecnicasGeovisor from "../../services/geovisor/getVisitasTecnicasGeovisor";

const { BaseLayer, Overlay } = LayersControl;
const colombiaBounds = [
  [-4.231, -79.03],
  [12.437, -66.758],
];

// Merge para que L.Icon.Default conozca dónde están
L.Icon.Default.mergeOptions({
  iconUrl,
  iconRetinaUrl,
  shadowUrl,
});
const colorPorNumeroVisita = {
  1: "#8e7cc3", // violeta frío
  2: "#6aa84f", // verde fuerte
  3: "#f6b26b", // naranja fuerte
  4: "#c19a6b", // caramelo tostado (reemplazo del rojo oscuro)
  5: "#c27ba0", // violeta fuerte
  6: "#ffd966", // amarillo fuerte
  7: "#a4a4a4", // gris medio
  8: "#444444", // gris oscuro
  9: "#e691b2", // rosado fuerte
  10: "#93c47d", // verde medio
  11: "#ffe599", // amarillo medio
  12: "#ff6f00", // naranja quemado (reemplazo del azul intenso)
  13: "#e69138", // naranja intenso
  14: "#a64d79", // púrpura fuerte
  15: "#76a5af", // cian fuerte
};

const trianguloIcono = L.divIcon({
  html: renderToString(
    <div className="triangulo-custom">
      <AlertOutlined style={{ color: "#8d6e63", fontSize: "14px" }} />
    </div>
  ),
  className: "",
  iconSize: [30, 30],
  iconAnchor: [15, 30], // para que la punta del triángulo esté justo donde es el punto
});

const MarcadorPersonalizado = (color = "#1890ff") => {
  return L.divIcon({
    html: renderToString(
      <div className="marcador-custom" style={{ backgroundColor: color }}></div>
    ),
    className: "",
    iconSize: [30, 42],
    iconAnchor: [15, 42],
  });
};

const geojsonSostenibilidad = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-77.134056, 1.950056], // Ejemplo: Bogotá
      },
      properties: {
        nombre: "COOMEEP - CERDOS",
        actividadProductiva: "Porcicultura",
        Sector: "Pecuaria",
        latitud: 1.950056,
        longitud: -77.134056,
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-77.109503, 1.973731], // [longitud, latitud]
      },
      properties: {
        nombre: "COOPATIA",
        actividadProductiva: "Porcicultura",
        Sector: "Pecuaria",
        latitud: 1.973731,
        longitud: -77.109503,
      },
    },

    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-76.45633, 2.93473], // [longitud, latitud]
      },
      properties: {
        nombre: "AMIFP",
        actividadProductiva: "Prooduccion de huevos / Gallinas",
        Sector: "Agrícola",
        latitud: 2.93473,
        longitud: -76.45633,
      },
    },

    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-76.436081, 2.680774], // [longitud, latitud]
      },
      properties: {
        nombre: "COOMEEP - PECES",
        actividadProductiva: "Piscicultura",
        Sector: "Pecuaria",
        latitud: 2.680774,
        longitud: -76.436081,
      },
    },

    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-77.24906, 2.25823], // [longitud, latitud]
      },
      properties: {
        nombre: "CEMAS",
        actividadProductiva: "Piscicultura",
        Sector: "Pecuaria",
        latitud: 2.25823,
        longitud: -77.24906,
      },
    },

    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-73.833819, 3.371254], // [longitud, latitud]
      },
      properties: {
        nombre: "COOPROAGROMETA",
        actividadProductiva: "Ganadería Bovina",
        Sector: "Pecuaria",
        latitud: 3.371254,
        longitud: -73.833819,
      },
    },

    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-73.888167, 3.690972], // [longitud, latitud]
      },
      properties: {
        nombre: "Hato del Castillo del Meta",
        actividadProductiva: "Porcicultura",
        Sector: "Pecuaria",
        latitud: 3.690972,
        longitud: -73.888167,
      },
    },

    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-76.60143, 2.44422], // [longitud, latitud]
      },
      properties: {
        nombre: "ASOMANUELTAS",
        actividadProductiva: "",
        Sector: "",
        latitud: 2.44422,
        longitud: -76.60143,
      },
    },

    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-74.222424, 3.359495], // [longitud, latitud]
      },
      properties: {
        nombre: "ASCORLLA",
        actividadProductiva: "Café",
        Sector: "Agrícola",
        latitud: 3.359495,
        longitud: -74.222424,
      },
    },

    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-73.518094, 3.93481], // [longitud, latitud]
      },
      properties: {
        nombre: "COAGRANCC",
        actividadProductiva: "Piscicultura",
        Sector: "Pecuaria",
        latitud: 3.93481,
        longitud: -73.518094,
      },
    },

    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-73.51532, 3.921753], // [longitud, latitud]
      },
      properties: {
        nombre: "COOMULDG",
        actividadProductiva: "Ganadería Bovina",
        Sector: "Pecuaria",
        latitud: 3.921753,
        longitud: -73.51532,
      },
    },

    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-73.76495, 3.75266], // [longitud, latitud]
      },
      properties: {
        nombre: "DAINCOOP",
        actividadProductiva: "Ganadería Bovina",
        Sector: "Pecuaria",
        latitud: 3.75266,
        longitud: -73.76495,
      },
    },

    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-72.63897, 2.57085], // [longitud, latitud]
      },
      properties: {
        nombre: "COOJAPAL",
        actividadProductiva: "Ganadería Bovina",
        Sector: "Pecuaria",
        latitud: 2.57085,
        longitud: -72.63897,
      },
    },

    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-75.5176, 2.804366], // [longitud, latitud]
      },
      properties: {
        nombre: "COOAGROPAZ",
        actividadProductiva: "Ganaderia bovina",
        Sector: "Pecuaria",
        latitud: 2.804366,
        longitud: -75.5176,
      },
    },

    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-75.0642, 2.91329], // [longitud, latitud]
      },
      properties: {
        nombre: "ASOEMANCIPADORAS",
        actividadProductiva: "Comercialización de café",
        Sector: "Agrícola",
        latitud: 2.804366,
        longitud: -75.5176,
      },
    },
  ],
};

export default function GeovisorPaati() {
  const [loading, setLoading] = useState(true);
  const [dataVisitasTecnicasGeovisor, setDataVisitasTecnicasGeovisor] =
    useState(null);

  const [sostenibilidad, setSostenibilidad] = useState(geojsonSostenibilidad);
  const [mostrarSostenibilidad, setMostrarSostenibilidad] = useState(false);

  const [dataOriginal, setDataOriginal] = useState(null); // Datos originales sin filtrar



  const [filtroDepartamento, setFiltroDepartamento] = useState("");
  const [filtroMunicipio, setFiltroMunicipio] = useState("");
  const [filtroCodigoSIRR, setFiltroCodigoSIRR] = useState("");
  // Cambia el estado para selección múltiple
  const [filtroNumerovisita, setFiltroNumerovisita] = useState([]);

  const [departamentosUnicos, setDepartamentosUnicos] = useState([]);
  const [municipiosUnicos, setMunicipiosUnicos] = useState([]);
  const [codigosSIRRUnicos, setCodigosSIRRUnicos] = useState([]);
  const [numeroVisitaUnicas, setNumeroVisitaUnicas] = useState([]);
  const [visibleModalAnalisisCompleto, setVisibleModalAnalisisCompleto] =
    useState(false);

  //Control de Permisos
  const appName = "mapa-paati"; // El nombre de la aplicación actual
  const permissions = useSelector((state) =>
    selectAppPermissions(state, appName)
  );

  const permissionExport = permissions.priv_export === "Y";

  const [capas, setCapas] = useState({});

  const cargarCapa = async (key, url) => {
    if (capas[key]) return; // ✅ ya cargada en cache, no repitas fetch

    try {
      const resp = await fetch(url);
      const data = await resp.json();

      setCapas((prev) => ({ ...prev, [key]: data }));
    } catch (error) {
      console.error("Error cargando capa:", key, error);
    }
  };

  // Municipios únicos según el departamento seleccionado
  const municipiosFiltrados = useMemo(() => {
    const features = dataOriginal?.features || [];
    return [
      ...new Set(
        features
          .filter(
            (f) =>
              !filtroDepartamento ||
              f.properties.departamento === filtroDepartamento
          )
          .map((f) => f.properties.municipio)
          .filter(Boolean)
      ),
    ];
  }, [dataOriginal, filtroDepartamento]);

  // Códigos SIRR únicos según el municipio y/o departamento seleccionado
  const codigosSIRRFiltrados = useMemo(() => {
    const features = dataOriginal?.features || [];
    return [
      ...new Set(
        features
          .filter(
            (f) =>
              (!filtroDepartamento ||
                f.properties.departamento === filtroDepartamento) &&
              (!filtroMunicipio || f.properties.municipio === filtroMunicipio)
          )
          .map((f) => f.properties.codigoSIRR)
          .filter(Boolean)
      ),
    ];
  }, [dataOriginal, filtroDepartamento, filtroMunicipio]);

  //Numero visita únicos según el municipio y/o departamento /o codigo sirr seleccionado
  // Cambia el filtro de visitas para aceptar múltiples valores
  const numerovisitaFiltrados = useMemo(() => {
    const features = dataOriginal?.features || [];
    return [
      ...new Set(
        features
          .filter(
            (f) =>
              (!filtroDepartamento ||
                f.properties.departamento === filtroDepartamento) &&
              (!filtroMunicipio ||
                f.properties.municipio === filtroMunicipio) &&
              (!filtroCodigoSIRR ||
                f.properties.codigoSIRR === filtroCodigoSIRR)
          )
          .map((f) => f.properties.numero_visita)
          .filter(Boolean)
      ),
    ];
  }, [dataOriginal, filtroDepartamento, filtroMunicipio, filtroCodigoSIRR]);

  // Modifica el filtrado de datos para aceptar múltiples visitas
  useEffect(() => {
    if (!dataOriginal) return;

    const features = dataOriginal.features || [];

    const filtradas = features.filter((f) => {
      const p = f.properties;

      return (
        (filtroDepartamento === "" || p.departamento === filtroDepartamento) &&
        (filtroMunicipio === "" || p.municipio === filtroMunicipio) &&
        (filtroCodigoSIRR === "" || p.codigoSIRR === filtroCodigoSIRR) &&
        (filtroNumerovisita.length === 0 ||
          filtroNumerovisita.includes(p.numero_visita))
      );
    });

    // Actualizar el estado con misma estructura FeatureCollection
    setDataVisitasTecnicasGeovisor({
      type: "FeatureCollection",
      features: filtradas,
    });
  }, [
    filtroDepartamento,
    filtroMunicipio,
    filtroCodigoSIRR,
    filtroNumerovisita,
    dataOriginal,
  ]);

  useEffect(() => {
    setLoading(true);
    const fetchDataVisitasTecnicas = async () => {
      try {
        const dataVisitas = await getVisitasTecnicasGeovisor();

        setDataVisitasTecnicasGeovisor(dataVisitas?.data);
        setDataOriginal(dataVisitas?.data);

        setLoading(false);
      } catch (err) {
        console.error("Error al obtener data:", err);
      }
    };

    fetchDataVisitasTecnicas();
  }, []);

  useEffect(() => {
    if (dataVisitasTecnicasGeovisor && dataVisitasTecnicasGeovisor.features) {
      const features = dataVisitasTecnicasGeovisor.features;

      setDepartamentosUnicos([
        ...new Set(
          features.map((f) => f.properties.departamento).filter(Boolean)
        ),
      ]);
      setMunicipiosUnicos([
        ...new Set(features.map((f) => f.properties.municipio).filter(Boolean)),
      ]);
      setCodigosSIRRUnicos([
        ...new Set(
          features.map((f) => f.properties.codigoSIRR).filter(Boolean)
        ),
      ]);

      setNumeroVisitaUnicas([
        ...new Set(
          features.map((f) => f.properties.numero_visita).filter(Boolean)
        ),
      ]);
    } else {
      setDepartamentosUnicos([]);
      setMunicipiosUnicos([]);
      setCodigosSIRRUnicos([]);
      setNumeroVisitaUnicas([]);
    }
  }, [dataOriginal]);


  // Función para calcular distancia usando fórmula de Haversine
  function calcularDistancia(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radio de la Tierra en km
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distancia en km
    return d;
  }

  function obtenerDistanciasConsecutivasPorCodigoSIRR(data) {
    if (!data?.features) return [];

    // Agrupar las visitas por codigoSIRR
    const visitasPorCodigo = data.features.reduce((acc, visita) => {
      const codigo = visita.properties.codigoSIRR;
      if (!acc[codigo]) acc[codigo] = [];
      acc[codigo].push(visita);
      return acc;
    }, {});

    const resultados = [];

    Object.values(visitasPorCodigo).forEach((visitas) => {
      // Ordenar por número de visita
      const ordenadas = visitas.sort(
        (a, b) =>
          Number(a.properties.numero_visita) -
          Number(b.properties.numero_visita)
      );

      // Buscar la visita 2 como referencia
      const visita2 = ordenadas.find(
        (v) => Number(v.properties.numero_visita) === 2
      );

      if (!visita2) {
        // Si no hay visita 2, usar la primera como referencia
        const primera = ordenadas[0];
        ordenadas.slice(1).forEach((v) => {
          const lat1 = primera.geometry.coordinates[1];
          const lon1 = primera.geometry.coordinates[0];
          const lat2 = v.geometry.coordinates[1];
          const lon2 = v.geometry.coordinates[0];
          const distancia = calcularDistancia(lat1, lon1, lat2, lon2);
          resultados.push({
            codigoSIRR: v.properties.codigoSIRR,
            nombreParticipante: v.properties.nombreParticipante,
            departamento: v.properties.departamento,
            municipio: v.properties.municipio,
            vereda: v.properties.vereda,
            nombreProyecto: v.properties.nombreProyecto,
            nombreProfesionalAsistenteTecnico:
              v.properties.nombreProfesionalAsistenteTecnico,
            modalidad: v.properties.modalidad,
            modalidad_sesion_capacitacion:
              v.properties.modalidad_sesion_capacitacion,
            visita1: primera.properties.numero_visita,
            fecha1: primera.properties.fecha_registro,
            lat1,
            lon1,
            visita2: v.properties.numero_visita,
            fecha2: v.properties.fecha_registro,
            lat2,
            lon2,
            distancia: Math.round(distancia * 1000) / 1000,
          });
        });
      } else {
        // Calcular distancias desde la visita 2
        ordenadas
          .filter((v) => Number(v.properties.numero_visita) !== 2)
          .forEach((v) => {
            const lat1 = visita2.geometry.coordinates[1];
            const lon1 = visita2.geometry.coordinates[0];
            const lat2 = v.geometry.coordinates[1];
            const lon2 = v.geometry.coordinates[0];
            const distancia = calcularDistancia(lat1, lon1, lat2, lon2);
            resultados.push({
              codigoSIRR: v.properties.codigoSIRR,
              nombreParticipante: v.properties.nombreParticipante,
              departamento: v.properties.departamento,
              municipio: v.properties.municipio,
              vereda: v.properties.vereda,
              nombreProyecto: v.properties.nombreProyecto,
              nombreProfesionalAsistenteTecnico:
                v.properties.nombreProfesionalAsistenteTecnico,

              modalidad: v.properties.modalidad,
              modalidad_sesion_capacitacion:
                v.properties.modalidad_sesion_capacitacion,
              visita1: visita2.properties.numero_visita,
              fecha1: visita2.properties.fecha_registro,
              lat1,
              lon1,
              visita2: v.properties.numero_visita,
              fecha2: v.properties.fecha_registro,
              lat2,
              lon2,
              distancia: Math.round(distancia * 1000) / 1000,
            });
          });
      }
    });

    return resultados;
  }

  const columnsAnalisisCompleto = [
    {
      title: <Tooltip title="codigo SIRR">Codigo SIRR</Tooltip>,
      dataIndex: "codigoSIRR",
      key: "codigoSIRR",
      width: 120,
    },
    {
      title: <Tooltip title="Participante">Participante</Tooltip>,
      dataIndex: "nombreParticipante",
      key: "nombreParticipante",
      width: 120,
    },

    {
      title: <Tooltip title="Departamento">Departamento</Tooltip>,
      dataIndex: "departamento",
      key: "departamento",
      width: 120,
    },

    {
      title: <Tooltip title="Municipio">Municipio</Tooltip>,
      dataIndex: "municipio",
      key: "municipio",
      width: 120,
    },
    {
      title: <Tooltip title="Vereda">Vereda</Tooltip>,
      dataIndex: "vereda",
      key: "vereda",
      width: 120,
    },

    {
      title: <Tooltip title="Proyecto">Proyecto</Tooltip>,
      dataIndex: "nombreProyecto",
      key: "nombreProyecto",
      width: 120,
    },

    {
      title: <Tooltip title="Nombre técnico">Nombre técnico</Tooltip>,
      dataIndex: "nombreProfesionalAsistenteTecnico",
      key: "nombreProfesionalAsistenteTecnico",
      width: 120,
    },

    {
      title: (
        <Tooltip title="Modalidad de la sesión de capacitación">
          Modalidad de capacitación
        </Tooltip>
      ),
      dataIndex: "modalidad_sesion_capacitacion",
      key: "modalidad_sesion_capacitacion",
      width: 120,
    },

    {
      title: <Tooltip title="Modalidad">Modalidad</Tooltip>,
      dataIndex: "modalidad",
      key: "modalidad",
      width: 120,
    },

    {
      title: (
        <Tooltip title="Número de la visita de referencia (usualmente la visita 2)">
          Visita Ref.
        </Tooltip>
      ),
      dataIndex: "visita1",
      key: "visita1",
      width: 120,
    },
    {
      title: (
        <Tooltip title="Fecha de la visita de referencia">Fecha Ref.</Tooltip>
      ),
      dataIndex: "fecha1",
      key: "fecha1",
      width: 120,
    },
    {
      title: (
        <Tooltip title="Latitud de la visita de referencia">Lat Ref.</Tooltip>
      ),
      dataIndex: "lat1",
      key: "lat1",
      width: 100,
    },
    {
      title: (
        <Tooltip title="Longitud de la visita de referencia">Lon Ref.</Tooltip>
      ),
      dataIndex: "lon1",
      key: "lon1",
      width: 100,
    },
    {
      title: <Tooltip title="Número de la visita">Visita</Tooltip>,
      dataIndex: "visita2",
      key: "visita2",
      width: 120,
    },
    {
      title: <Tooltip title="Fecha de la visita">Fecha</Tooltip>,
      dataIndex: "fecha2",
      key: "fecha2",
      width: 120,
    },
    {
      title: <Tooltip title="Latitud de la visita">Latitud</Tooltip>,
      dataIndex: "lat2",
      key: "lat2",
      width: 100,
    },
    {
      title: <Tooltip title="Longitud de la visita">Longitud</Tooltip>,
      dataIndex: "lon2",
      key: "lon2",
      width: 100,
    },
    {
      title: (
        <Tooltip title="Distancia en kilómetros entre la visita de referencia y la comparada">
          Distancia (km)
        </Tooltip>
      ),
      dataIndex: "distancia",
      key: "distancia",
      width: 150,
      render: (dist) => {
        let color = "#22c55e"; // verde
        if (dist > 2) color = "#ef4444"; // rojo
        else if (dist > 1) color = "#facc15"; // amarillo
        return (
          <span
            style={{
              fontWeight: "bold",
              color: color,
              background:
                color === "#facc15"
                  ? "#fef9c3"
                  : color === "#ef4444"
                  ? "#fee2e2"
                  : "#dcfce7",
              padding: "4px 10px",
              borderRadius: "8px",
              display: "inline-block",
              minWidth: "60px",
              textAlign: "center",
            }}
          >
            {dist}
          </span>
        );
      },
    },
  ];

  const exportarDatosAnalisisCompleto = () => {
    const datos = obtenerDistanciasConsecutivasPorCodigoSIRR(
      dataVisitasTecnicasGeovisor
    );

    if (!datos.length) return;

    // Mapeo de los datos con claves como nombres de columna (cabeceras automáticas)
    const datosFormateados = datos.map((item) => ({
      "CÓDIGO SIR": item.codigoSIRR,
      "NOMBRE DEL PARTICIPANTE": item.nombreParticipante,
      DEPARTAMENTO: item.departamento,
      MUNICIPIO: item.municipio,
      VEREDA: item.vereda,
      "NOMBRE DEL PROYECTO": item.nombreProyecto,
      "NOMBRE DEL TÉCNICO": item.nombreProfesionalAsistenteTecnico,
      "MODALIDAD DE CAPACITACIÓN": item.modalidad_sesion_capacitacion,
      MODALIDAD: item.modalidad,
      "VISITA DE REFERENCIA": item.visita1,
      "FECHA DE REFERENCIA": item.fecha1,
      "LATITUD DE REFERENCIA": item.lat1,
      "LONGITUD DE REFERENCIA": item.lon1,
      "NÚMERO DE VISITA": item.visita2,
      "FECHA VISITA": item.fecha2,
      LATITUD: item.lat2,
      LONGITUD: item.lon2,
      "DISTANCIA (KM)": item.distancia,
    }));

    // Crear hoja con cabeceras automáticas
    const worksheet = XLSX.utils.json_to_sheet(datosFormateados);

    // Obtener número de columnas
    const keys = Object.keys(datosFormateados[0]);

    // Aplicar estilos a la fila de cabecera (primera fila)
    keys.forEach((_, colIdx) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIdx });
      const cell = worksheet[cellAddress];

      if (cell) {
        cell.s = {
          fill: {
            patternType: "solid",
            fgColor: { rgb: "D9E1F2" }, // Azul claro
          },
          font: {
            bold: true,
            color: { rgb: "000000" },
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        };
      }
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Distancias");

    XLSX.writeFile(workbook, "analisis_distancias_entre_visitasTecnicas.xlsx", {
      cellStyles: true,
    });
  };

  const hayFiltros = !!(
    filtroDepartamento ||
    filtroMunicipio ||
    filtroCodigoSIRR ||
    filtroNumerovisita.length > 0
  );

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        background: "#f5f5f5",
        width: "100%",
      }}
    >
      {loading ? (
        <div
          style={{
            minHeight: "100vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin size="large" tip="Cargando datos..." />
        </div>
      ) : (
        <>
          {/* Sidebar izquierdo */}
          <div
            style={{
              width: 350,
              minWidth: 280,
              maxWidth: 400,
              background: "#fff",
              borderRight: "1px solid #e5e7eb",
              padding: 24,
              display: "flex",
              flexDirection: "column",
              gap: 24,
              boxShadow: "2px 0 8px 0 rgba(0,0,0,0.03)",
            }}
          >
            {/* Header Section */}
            <div>
              <h2
                style={{
                  margin: 0,
                  color: "#1f2937",
                  fontSize: "28px",
                  fontWeight: "600",
                  marginBottom: "8px",
                }}
              >
                Geovisor de Visitas Técnicas - PAATI
              </h2>
              <p
                style={{
                  margin: 0,
                  color: "#6b7280",
                  fontSize: "16px",
                }}
              >
                Visualización y gestión de visitas técnicas territoriales
              </p>
            </div>

            {/* Filtros */}
            <Card
              style={{
                borderRadius: "12px",
                border: "1px solid #e5e7eb",
                boxShadow: "0 2px 8px 0 rgba(0,0,0,0.03)",
                margin: 0,
              }}
              bodyStyle={{ padding: "16px" }}
            >
              <h3
                style={{
                  margin: 0,
                  color: "#374151",
                  fontSize: "18px",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginBottom: "16px",
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    width: "4px",
                    height: "20px",
                    backgroundColor: "#3b82f6",
                    borderRadius: "2px",
                  }}
                ></span>
                Filtros de Búsqueda
              </h3>
              <Form layout="vertical">
                <Row gutter={[0, 8]}>
                  <Col span={24}>
                    <Form.Item
                      label={
                        <span style={{ fontWeight: "500", color: "#374151" }}>
                          Departamento
                        </span>
                      }
                      style={{ marginBottom: "8px" }}
                    >
                      <Select
                        allowClear
                        showSearch
                        placeholder="Seleccionar departamento"
                        value={filtroDepartamento || undefined}
                        onChange={(value) => {
                          setFiltroDepartamento(value || "");
                          setFiltroMunicipio("");
                          setFiltroCodigoSIRR("");
                        }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.children ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        style={{ borderRadius: "8px", height: "40px" }}
                      >
                        {departamentosUnicos.map((dep) => (
                          <Select.Option key={dep} value={dep}>
                            {dep}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label={
                        <span style={{ fontWeight: "500", color: "#374151" }}>
                          Municipio
                        </span>
                      }
                      style={{ marginBottom: "8px" }}
                    >
                      <Select
                        allowClear
                        showSearch
                        placeholder="Seleccionar municipio"
                        value={filtroMunicipio || undefined}
                        onChange={(value) => {
                          setFiltroMunicipio(value || "");
                          setFiltroCodigoSIRR("");
                        }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.children ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        style={{ borderRadius: "8px", height: "40px" }}
                      >
                        {municipiosFiltrados.map((mun) => (
                          <Select.Option key={mun} value={mun}>
                            {mun}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label={
                        <span style={{ fontWeight: "500", color: "#374151" }}>
                          Código SIRR
                        </span>
                      }
                      style={{ marginBottom: "8px" }}
                    >
                      <Select
                        allowClear
                        showSearch
                        placeholder="Seleccionar código SIRR"
                        value={filtroCodigoSIRR || undefined}
                        onChange={(value) => setFiltroCodigoSIRR(value || "")}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.children ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        style={{ borderRadius: "8px", height: "40px" }}
                      >
                        {codigosSIRRFiltrados.map((cod) => (
                          <Select.Option key={cod} value={cod}>
                            {cod}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label={
                        <span style={{ fontWeight: "500", color: "#374151" }}>
                          Número de Visita
                        </span>
                      }
                      style={{ marginBottom: "8px" }}
                    >
                      <Select
                        mode="multiple"
                        allowClear
                        showSearch
                        placeholder="Seleccionar número"
                        value={filtroNumerovisita}
                        onChange={(value) => setFiltroNumerovisita(value)}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.children ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        style={{ borderRadius: "8px", minHeight: "40px" }}
                      >
                        {numerovisitaFiltrados.map((cod) => (
                          <Select.Option key={cod} value={cod}>
                            <span
                              style={{
                                display: "inline-block",
                                width: 16,
                                height: 16,
                                borderRadius: "50%",
                                background: colorPorNumeroVisita[cod] || "red",
                                marginRight: 8,
                                border: "1px solid #ccc",
                                verticalAlign: "middle",
                              }}
                            />
                            <span style={{ verticalAlign: "middle" }}>
                              {cod}
                            </span>
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Button
                      onClick={() => {
                        setFiltroDepartamento("");
                        setFiltroMunicipio("");
                        setFiltroCodigoSIRR("");
                        setFiltroNumerovisita([]);
                      }}
                      style={{ width: "100%", marginTop: 8 }}
                      type="default"
                      icon={<ReloadOutlined />}
                      disabled={!hayFiltros}
                    >
                      Limpiar Filtros
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card>

            {/* Contadores y botones */}
            <Card
              style={{
                borderRadius: "12px",
                border: "1px solid #e5e7eb",
                boxShadow: "0 2px 8px 0 rgba(0,0,0,0.03)",
                margin: 0,
              }}
              bodyStyle={{ padding: "16px" }}
            >
              <div
                style={{ display: "flex", flexDirection: "column", gap: 16 }}
              >
                {/* Contadores */}
                <div style={{ display: "flex", gap: 12, marginBottom: 8 }}>
                  <div
                    style={{
                      flex: 1,
                      padding: "12px",
                      backgroundColor: "#f0fdf4",
                      borderRadius: "8px",
                      border: "1px solid #dcfce7",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#6b7280",
                        fontWeight: "500",
                        marginBottom: "2px",
                      }}
                    >
                      Visitas Activas
                    </div>
                    <div
                      style={{
                        fontSize: "20px",
                        color: "#1f2937",
                        fontWeight: "700",
                        lineHeight: "1",
                      }}
                    >
                      {dataVisitasTecnicasGeovisor?.features?.length?.toLocaleString() ||
                        0}
                    </div>
                  </div>
                </div>
                {/* Botones
                <Button
                  type="primary"
                  size="large"
                  onClick={() => setVisibleModalTabla(true)}
                  style={{
                    borderRadius: "8px",
                    height: "44px",
                    fontSize: "16px",
                    fontWeight: "500",
                    background:
                      "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                    border: "none",
                    boxShadow: "0 4px 6px -1px rgba(59, 130, 246, 0.5)",
                    marginBottom: 8,
                  }}
                >
                  📊 Ver Tabla Detallada
                </Button>
 */}

                {permissionExport && (
                  <Button
                    type="primary"
                    size="large"
                    onClick={() => setVisibleModalAnalisisCompleto(true)}
                    style={{
                      borderRadius: "8px",
                      height: "44px",
                      fontSize: "16px",
                      fontWeight: "500",
                      background:
                        "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                      border: "none",
                      boxShadow: "0 4px 6px -1px rgba(59, 130, 246, 0.5)",
                      marginBottom: 8,
                    }}
                  >
                    📊 Ver detalle
                  </Button>
                )}

                {/* Botones 
                {filtroCodigoSIRR && (
                  <Button
                    type="default"
                    size="large"
                    onClick={() => setVisibleModalAnalisis(true)}
                    style={{
                      borderRadius: "8px",
                      height: "44px",
                      fontSize: "16px",
                      fontWeight: "500",
                      background: "#fff",
                      border: "1px solid #3b82f6",
                      color: "#1d4ed8",
                      boxShadow: "0 2px 4px -1px rgba(59, 130, 246, 0.1)",
                    }}
                  >
                    📏 Análisis de Distancias
                  </Button>
                )}
                  */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginTop: 8,
                  }}
                >
                  <span style={{ fontSize: "14px", color: "#374151" }}>
                    Habilitar puntos de sostenibilidad
                  </span>
                  <Switch
                    checked={mostrarSostenibilidad}
                    onChange={setMostrarSostenibilidad}
                    size="small"
                  />
                </div>
              </div>
            </Card>
          </div>

          {/* Panel derecho: el mapa */}
          <div style={{ flex: 1, padding: 24, minWidth: 0 }}>
            <Card
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow:
                  "0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                border: "1px solid #e5e7eb",
                height: "100%",
              }}
              bodyStyle={{ padding: 0, height: "100%", borderRadius: "12px" }} // 👈 truco
            >
              <MapContainer
                bounds={colombiaBounds}
                maxBounds={colombiaBounds}
                maxBoundsViscosity={1}
                minZoom={6}
                zoom={13}
                style={{
                  height: "100%",
                  width: "100%",
                  borderRadius: "12px",
                }}
                scrollWheelZoom={false}
              >
                <LayersControl position="topright">
                  <BaseLayer checked name="Mapa Base - Colombia">
                    <TileLayer
                      attribution="&copy; OpenStreetMap contributors"
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      noWrap
                    />
                  </BaseLayer>

                  {dataVisitasTecnicasGeovisor && (
                    <Overlay key="visitas" name="📍 Visitas Técnicas" checked>
                      <GeoJSON
                        data={dataVisitasTecnicasGeovisor}
                        key={`geojson-${dataVisitasTecnicasGeovisor.features.length}`}
                        style={() => styleVisitasPatti}
                        pointToLayer={(feature, latlng) => {
                          const numVisita = feature.properties.numero_visita;
                          // Usa el color fijo según el número de visita (por defecto rojo si no está en el mapa)
                          const color =
                            colorPorNumeroVisita[numVisita] || "red";
                          return L.marker(latlng, {
                            icon: MarcadorPersonalizado(color),
                          });
                        }}
                        onEachFeature={(feature, layer) => {
                          const p = feature.properties;
                          const fecha = p.fecha_registro;
                          const html = `
                              <div style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; font-size: 13px; line-height: 1.4; max-width: 300px;">
                                <div style="background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%); color: white; padding: 12px; margin: -10px -10px 12px -10px; border-radius: 8px 8px 0 0;">
                                  <h4 style="margin: 0; font-size: 16px; font-weight: 600;">🏢 Visita Técnica</h4>
                                  <p style="margin: 4px 0 0 0; opacity: 0.9;">Visita N° ${p.numero_visita}</p>
                                </div>
                                
                                <div style="margin-bottom: 12px;">
                                  <div style="display: flex; align-items: center; margin-bottom: 6px;">
                                    <span style="color: #6b7280; font-weight: 500; min-width: 80px;">📅 Fecha:</span>
                                    <span style="color: #1f2937;">${fecha}</span>
                                  </div>
                                  <div style="display: flex; align-items: center; margin-bottom: 6px;">
                                    <span style="color: #6b7280; font-weight: 500; min-width: 80px;">Ubicación:</span>
                                    <span style="color: #1f2937;">${p.departamento}, ${p.municipio}</span>
                                  </div>
                                  <div style="display: flex; align-items: center; margin-bottom: 6px;">
                                    <span style="color: #6b7280; font-weight: 500; min-width: 80px;">🌱 Vereda:</span>
                                    <span style="color: #1f2937;">${p.vereda}</span>
                                  </div>
                                </div>

                                <div style="background-color: #f9fafb; padding: 10px; border-radius: 6px; margin-bottom: 12px;">
                                  <div style="font-weight: 600; color: #374151; margin-bottom: 6px;">🎯 Información del Proyecto</div>
                                  <div style="font-size: 12px; color: #6b7280; margin-bottom: 4px;">PREPP: <span style="color: #1f2937; font-weight: 500;">${p.codigoPREPP}</span></div>
                                  <div style="font-size: 12px; color: #6b7280;">Proyecto: <span style="color: #1f2937; font-weight: 500;">${p.nombreProyecto}</span></div>
                                </div>

                                <div style="margin-bottom: 12px;">
                                  <div style="display: flex; align-items: center; margin-bottom: 6px;">
                                    <span style="color: #6b7280; font-weight: 500; min-width: 100px;">👤 Participante:</span>
                                    <span style="color: #1f2937;">${p.nombreParticipante}</span>
                                  </div>
                                  <div style="display: flex; align-items: center; margin-bottom: 6px;">
                                    <span style="color: #6b7280; font-weight: 500; min-width: 100px;">🆔 Código SIRR:</span>
                                    <span style="color: #1f2937; font-weight: 600;">${p.codigoSIRR}</span>
                                  </div>
                                  <div style="display: flex; align-items: center; margin-bottom: 6px;">
                                    <span style="color: #6b7280; font-weight: 500; min-width: 100px;">👥 N° Personas:</span>
                                    <span style="color: #1f2937;">${p.numeroPersonasParticipan}</span>
                                  </div>
                                  <div style="display: flex; align-items: center; margin-bottom: 6px;">
                                    <span style="color: #6b7280; font-weight: 500; min-width: 100px;">🌾 Línea Prod.:</span>
                                    <span style="color: #1f2937;">${p.linea_productiva}</span>
                                  </div>
                                </div>

                                <div style="background-color: #fef3f2; padding: 10px; border-radius: 6px; border-left: 4px solid #ef4444;">
                                  <div style="font-weight: 600; color: #dc2626; margin-bottom: 6px;">👨‍💼 Técnico Responsable</div>
                                  <div style="font-size: 12px; color: #6b7280; margin-bottom: 4px;">
                                    Asistente: <span style="color: #1f2937; font-weight: 500;">${p.nombreProfesionalAsistenteTecnico}</span>
                                  </div>
                                  <div style="font-size: 12px; color: #6b7280;">
                                    Titular: <span style="color: #1f2937; font-weight: 500;">${p.nombreTitular}</span>
                                  </div>
                                </div>
                              </div>
                            `;

                          layer.bindPopup(html, {
                            maxHeight: 400,
                            maxWidth: 350,
                            autoPan: true,
                            autoPanPadding: [20, 20],
                            className: "custom-popup",
                          });
                        }}
                      />
                    </Overlay>
                  )}

                  <LayersControl.Overlay
                    key="consejosComunitarios"
                    name="Consejos comunitarios titulado"
                    checked={false}
                  >
                    <LayerGroup
                      eventHandlers={{
                        add: () =>
                          cargarCapa(
                            "consejosComunitarios",
                            "/capas/Consejo_Comunitario_Titulado.geojson"
                          ),
                      }}
                    >
                      {capas["consejosComunitarios"] && (
                        <GeoJSON
                          data={capas["consejosComunitarios"]}
                          style={() => styleconsejosComunitarios}
                          onEachFeature={(feature, layer) => {
                            const p = feature.properties;
                            const html = `
              <div style="font-family: 'Segoe UI', Arial, sans-serif; max-width: 320px;">
                <div style="background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%); color: white; padding: 10px 16px; border-radius: 8px 8px 0 0;">
                  <h4 style="margin: 0; font-size: 18px; font-weight: 700;">🟢 Consejo Comunitario Titulado</h4>
                </div>
                <div style="padding: 12px; background: #f9fafb; border-radius: 0 0 8px 8px;">
                  <div><strong>Nombre:</strong> ${p.NOMBRE || "—"}</div>
                </div>
              </div>
            `;
                            layer.bindPopup(html);
                          }}
                        />
                      )}
                    </LayerGroup>
                  </LayersControl.Overlay>

                  <LayersControl.Overlay
                    key="zonaReservaCampesinaConstituida"
                    name="Zonas de reserva campesina constituidas"
                    checked={false}
                  >
                    <LayerGroup
                      eventHandlers={{
                        add: () =>
                          cargarCapa(
                            "zonaReservaCampesinaConstituida",
                            "/capas/Zonas_de_Reserva_Campesina_Constituida.geojson"
                          ),
                      }}
                    >
                      {capas["zonaReservaCampesinaConstituida"] && (
                        <GeoJSON
                          data={capas["zonaReservaCampesinaConstituida"]}
                          style={() => stylezonaReservaCampesinaConstituida}
                          onEachFeature={(feature, layer) => {
                            const p = feature.properties;
                            const html = `
            <div style="font-family: 'Segoe UI', Arial, sans-serif; max-width: 320px;">
              <div style="background: linear-gradient(135deg, #f59e42 0%, #fbbf24 100%); color: white; padding: 10px 16px; border-radius: 8px 8px 0 0;">
                <h4 style="margin: 0; font-size: 18px; font-weight: 700;">🟠 Zona de Reserva Campesina</h4>
              </div>
              <div style="padding: 12px; background: #f9fafb; border-radius: 0 0 8px 8px;">
                <div><strong>Nombre:</strong> ${p.NOMBRE_ZON || "—"}</div>
                <div><strong>Resolución:</strong> ${p.RESOLUCION || "—"}</div>
              </div>
            </div>
          `;
                            layer.bindPopup(html);
                          }}
                        />
                      )}
                    </LayerGroup>
                  </LayersControl.Overlay>

                  <LayersControl.Overlay
                    key="resguardoIndigenaFormalizado"
                    name="Resguardos indígenas formalizados"
                    checked={false}
                  >
                    <LayerGroup
                      eventHandlers={{
                        add: () =>
                          cargarCapa(
                            "resguardoIndigenaFormalizado",
                            "/capas/Resguardo_Indigena_Formalizado.geojson"
                          ),
                      }}
                    >
                      {capas["resguardoIndigenaFormalizado"] && (
                        <GeoJSON
                          data={capas["resguardoIndigenaFormalizado"]}
                          style={() => styleresguardoIndigenaFormalizado}
                          onEachFeature={(feature, layer) => {
                            const p = feature.properties;
                            const html = `
            <div style="font-family: 'Segoe UI', Arial, sans-serif; max-width: 320px;">
              <div style="background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%); color: white; padding: 10px 16px; border-radius: 8px 8px 0 0;">
                <h4 style="margin: 0; font-size: 18px; font-weight: 700;">🔵 Resguardo Indígena</h4>
              </div>
              <div style="padding: 12px; background: #f9fafb; border-radius: 0 0 8px 8px;">
                <div><strong>Nombre:</strong> ${p.NOMBRE || "—"}</div>
                <div><strong>Área (ha):</strong> ${
                  p.AREA_TOTAL_ACTOS_ADMIN
                    ? Number(p.AREA_TOTAL_ACTOS_ADMIN).toLocaleString()
                    : "—"
                }</div>
              </div>
            </div>
          `;
                            layer.bindPopup(html);
                          }}
                        />
                      )}
                    </LayerGroup>
                  </LayersControl.Overlay>

                  <LayersControl.Overlay
                    key="reservaForestalNacional"
                    name="Reservas forestales nacionales"
                    checked={false}
                  >
                    <LayerGroup
                      eventHandlers={{
                        add: () =>
                          cargarCapa(
                            "reservaForestalNacional",
                            "/capas/Reserva_Forestal_Nacional_329062953925962160.geojson"
                          ),
                      }}
                    >
                      {capas["reservaForestalNacional"] && (
                        <GeoJSON
                          data={capas["reservaForestalNacional"]}
                          style={() => stylereservaForestalNacional}
                          pointToLayer={(feature, latlng) => {
                            const customIcon = L.icon({
                              iconUrl:
                                "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
                              iconSize: [25, 41],
                              iconAnchor: [12, 41],
                              popupAnchor: [1, -34],
                              shadowUrl:
                                "https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png",
                              shadowSize: [41, 41],
                            });
                            return L.marker(latlng, { icon: customIcon });
                          }}
                          onEachFeature={(feature, layer) => {
                            const p = feature.properties;
                            const html = `
            <div style="font-family: 'Segoe UI', Arial, sans-serif; max-width: 320px;">
              <div style="background: linear-gradient(135deg, #14532d 0%, #14532d 100%); color: white; padding: 10px 16px; border-radius: 8px 8px 0 0;">
                <h4 style="margin: 0; font-size: 18px; font-weight: 700;">🌲 Reserva forestal nacional</h4>
              </div>
              <div style="padding: 12px; background: #f9fafb; border-radius: 0 0 8px 8px;">
                <!-- Aquí puedes agregar más info si quieres -->
              </div>
            </div>
          `;
                            layer.bindPopup(html);
                          }}
                        />
                      )}
                    </LayerGroup>
                  </LayersControl.Overlay>

                  <LayersControl.Overlay
                    key="runap"
                    name="RUNAP"
                    checked={false}
                  >
                    <LayerGroup
                      eventHandlers={{
                        add: () => cargarCapa("runap", "/capas/runap.geojson"),
                      }}
                    >
                      {capas["runap"] && (
                        <GeoJSON
                          data={capas["runap"]}
                          style={() => stylerunap}
                          pointToLayer={(feature, latlng) => {
                            const customIcon = L.icon({
                              iconUrl:
                                "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
                              iconSize: [25, 41],
                              iconAnchor: [12, 41],
                              popupAnchor: [1, -34],
                              shadowUrl:
                                "https://unpkg.com/leaflet@1.9.3/dist/images/leaflet-shadow.png",
                              shadowSize: [41, 41],
                            });
                            return L.marker(latlng, { icon: customIcon });
                          }}
                          onEachFeature={(feature, layer) => {
                            const p = feature.properties;
                            const html = `
            <div style="font-family: 'Segoe UI', Arial, sans-serif; max-width: 320px;">
              <div style="background: linear-gradient(135deg, #8b5cf6 0%, #a21caf 100%); color: white; padding: 10px 16px; border-radius: 8px 8px 0 0;">
                <h4 style="margin: 0; font-size: 18px; font-weight: 700;">🟣 RUNAP</h4>
              </div>
              <div style="padding: 12px; background: #f9fafb; border-radius: 0 0 8px 8px;">
                <div><strong>Nombre:</strong> ${p.ap_nombre || "—"}</div>
                <div><strong>Área total (ha):</strong> ${
                  p.area_ha_to ? Number(p.area_ha_to).toLocaleString() : "—"
                }</div>
              </div>
            </div>
          `;
                            layer.bindPopup(html);
                          }}
                        />
                      )}
                    </LayerGroup>
                  </LayersControl.Overlay>

                  <LayersControl.Overlay
                    key="desagregacionRegional"
                    name="Desagregación regional"
                    checked={false}
                  >
                    <LayerGroup
                      eventHandlers={{
                        add: () =>
                          cargarCapa(
                            "desagregacionRegional",
                            "/capas/desagregacion_region.geojson"
                          ),
                      }}
                    >
                      {capas["desagregacionRegional"] && (
                        <GeoJSON
                          data={capas["desagregacionRegional"]}
                          style={() => styledesagregacionRegional}
                          pointToLayer={(feature, latlng) => {
                            const customIcon = L.icon({
                              iconUrl:
                                "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png",
                              iconSize: [25, 41],
                              iconAnchor: [12, 41],
                              popupAnchor: [1, -34],
                              shadowUrl:
                                "https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png",
                              shadowSize: [41, 41],
                            });
                            return L.marker(latlng, { icon: customIcon });
                          }}
                          onEachFeature={(feature, layer) => {
                            const p = feature.properties;
                            const html = `
            <div style="font-family: 'Segoe UI', Arial, sans-serif; max-width: 320px;">
              <div style="background: linear-gradient(135deg, #06b6d4 0%, #0ea5e9 100%); color: white; padding: 10px 16px; border-radius: 8px 8px 0 0;">
                <h4 style="margin: 0; font-size: 18px; font-weight: 700;">🔷 Desagregación regional</h4>
              </div>
              <div style="padding: 12px; background: #f9fafb; border-radius: 0 0 8px 8px;">
                <!-- Aquí puedes agregar los campos que quieras mostrar -->
              </div>
            </div>
          `;
                            layer.bindPopup(html);
                          }}
                        />
                      )}
                    </LayerGroup>
                  </LayersControl.Overlay>
                </LayersControl>

                {mostrarSostenibilidad && sostenibilidad && (
                  <GeoJSON
                    data={sostenibilidad}
                    pointToLayer={(feature, latlng) => {
                      return L.marker(latlng, { icon: trianguloIcono });
                    }}
                    onEachFeature={(feature, layer) => {
                      const p = feature.properties;
                      const html = `
          <div style="font-family: 'Segoe UI', Arial, sans-serif; max-width: 320px;">
            <div style="background: linear-gradient(135deg, #328BC7 0%, #328BC7 100%); color: #f9fafb; padding: 10px 16px; border-radius: 8px 8px 0 0;">
              <h4 style="margin: 0; font-size: 18px; font-weight: 700;">🌱 Sostenibilidad</h4>
            </div>
            <div style="padding: 12px; background: #f9fafb; border-radius: 0 0 8px 8px;">
              <div><strong>Proyecto:</strong> ${p.nombre}</div>
              <div><strong>Actividad productiva:</strong> ${p.actividadProductiva}</div>
              <div><strong>sector:</strong> ${p.Sector}</div>
              <div><strong>Coordenadas (latitud, longitud):</strong> ${p.latitud}, ${p.longitud} </div>
            </div>
          </div>
        `;
                      layer.bindPopup(html);
                    }}
                    checked
                  />
                )}
              </MapContainer>
            </Card>
          </div>

          <Modal
            open={visibleModalAnalisisCompleto}
            onCancel={() => setVisibleModalAnalisisCompleto(false)}
            footer={null}
            width="1000px"
            centered
            title={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "8px 0",
                }}
              >
                <span
                  style={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: "#22c55e",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "16px",
                  }}
                >
                  📏
                </span>
                <div>
                  <h3
                    style={{
                      margin: 0,
                      fontSize: "20px",
                      fontWeight: "600",
                      color: "#1f2937",
                    }}
                  >
                    Análisis de Distancias entre Visitas
                  </h3>
                  <p style={{ margin: 0, fontSize: "14px", color: "#6b7280" }}>
                    Distancia entre visitas consecutivas
                  </p>
                </div>
              </div>
            }
            styles={{
              header: {
                borderBottom: "1px solid #e5e7eb",
                paddingBottom: "16px",
              },
            }}
          >
            {/* Contenedor scrollable */}
            <div
              style={{ maxHeight: "70vh", overflowY: "auto", paddingRight: 8 }}
            >
              <Button
                type="primary"
                onClick={() => exportarDatosAnalisisCompleto()}
                style={{ marginBottom: 8 }}
              >
                Exportar a Excel
              </Button>

              <Table
                columns={columnsAnalisisCompleto}
                dataSource={obtenerDistanciasConsecutivasPorCodigoSIRR(
                  dataVisitasTecnicasGeovisor
                ).map((row, idx) => ({ ...row, key: idx }))}
                size="small"
                pagination={false}
                style={{ marginTop: "16px" }}
                locale={{
                  emptyText: "No hay suficientes visitas para analizar.",
                }}
              />
            </div>
          </Modal>

        </>
      )}
    </div>
  );
}
